import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { Reconnect } from 'federation/Reconnect';
import type { CancellationConfirmationModalProps } from 'reconnect-types/moduleFederation';

export const CancellationConfirmationModalInitializer = ({
  onClose,
  onCancel,
  onReschedule,
  onUnmount,
  ...otherProps
}: CancellationConfirmationModalProps): Initializer => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="CancellationConfirmationModal"
        props={{
          onClose: () => {
            onClose?.();
            destroy();
          },
          onCancel: (params: { includeFutureRecurrences: boolean | null }) => {
            onCancel?.(params);
          },
          onUnmount: () => {
            onUnmount?.();
            destroy();
          },
          onReschedule: (event: React.MouseEvent<HTMLButtonElement>) => {
            onReschedule?.(event);
            destroy();
          },
          ...otherProps,
        }}
      />,
      container,
    );
  };

  return { destroy, render };
};
